// extracted by mini-css-extract-plugin
export default {"tasks":"MN-z","task":"NN-z","svg":"ON-z","text":"PN-z"};